import firebase from '../../firebase';

const logEvent = (name, params) => firebase.analytics().logEvent(name, params);

export default logEvent;
